import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CardDetail, CardId } from '@voll-intelligence/domain';

import { queryKeys } from '@web/core/query';
import { boardRepository } from '@web/data/repositories';

import { useOrgContext } from './use_org_context';

/**
 * Card detail for the drawer. Shared by the header and every tab view that
 * needs the brief / customer / identity fields — TanStack Query dedupes the
 * concurrent reads by `queryKeys.cards.detail`, so each view stays
 * self-contained while issuing a single network request.
 */
export function useCardDetail(cardId: CardId | undefined): UseQueryResult<CardDetail> {
  const { orgId } = useOrgContext();
  return useQuery({
    queryKey: queryKeys.cards.detail(orgId, cardId as CardId),
    queryFn: () => boardRepository.loadCardDetail(orgId, cardId as CardId),
    enabled: !!cardId,
  });
}
